import { createPlacementComponent } from '@post-office/placement-contexts/create-placement-component';

import { useInitialData } from '@post-office/placement-contexts/hooks';

import { PLACEMENT_ID } from '../__generated__/common';

import { withAppSwitcherUpgradeSectionIntlProvider } from '../__generated__/intl-provider';

import { type AppSwitcherUpgradeSectionInitialData } from '../api/types';

import { type Placement as AppSwitcherUpgradeSectionPlacement } from '../contracts/Placement';

import type { Fetcher } from '@atlassian/post-office-placement-data/types';

import { type OnPerformanceTrackingEvent } from '@post-office/placement-contexts/create-placement-component/hooks/usePerformanceTracking/types';

import {
	type ContextWithRoute,
	type FallbackRenderFacade,
} from '@post-office/placement-contexts/create-placement-component/types';

import { type ComponentType } from 'react';

import { type ErrorBoundaryPropsWithRender } from 'react-error-boundary';

export const AppSwitcherUpgradeSectionPlacementComponent: ComponentType<
	Partial<ErrorBoundaryPropsWithRender> & {
		context: ContextWithRoute;
		initialData: Promise<Response | undefined> | undefined;
		fetch?: Fetcher;
		onEvent?: OnPerformanceTrackingEvent;
	} & object &
		FallbackRenderFacade & {
			messages?: {
				[x: string]: string;
			};
		}
> = withAppSwitcherUpgradeSectionIntlProvider(
	createPlacementComponent<AppSwitcherUpgradeSectionPlacement>(PLACEMENT_ID, ({ initialData }) => {
		const initialDataState = useInitialData<AppSwitcherUpgradeSectionInitialData>(initialData);

		if (initialDataState.isLoading) {
			// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
			return <p>Loading</p>;
		}

		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
		return <p>`This is the app-switcher-upgrade-section-placement.`</p>;
	}),
);

export default AppSwitcherUpgradeSectionPlacementComponent;
